export const formatCurrency = (
  val: number | string | null | undefined,
): string => {
  const amount = Number(val ?? 0)
  if (!Number.isFinite(amount)) return '$0.00'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}

export const formatInvoiceNumber = (
  invoiceNo: string | null | undefined,
): string => {
  if (!invoiceNo) return '-'
  return `INV${invoiceNo.slice(0, 7).toUpperCase()}`
}

export const formatAppointmentId = (
  appointmentId: string | null | undefined,
): string => {
  if (!appointmentId) return '-'
  return `APPT${appointmentId.slice(0, 7).toUpperCase()}`
}

export const readSelectValue = (value: string | string[]): string =>
  typeof value === 'string' ? value : (value[0] ?? '')

export const hasBillingListNarrowed = (
  searchQuery: string,
  filters: Record<string, string[]>,
): boolean =>
  searchQuery.trim().length > 0 ||
  Object.values(filters).some((values) => (values?.length ?? 0) > 0)
